{
  "title": "Merknad",
  "label": "Merknad",
  "create": "Opprett merknad",
  "edit": "Endre merknad",
  "delete": "Slett merknad",
  "empty": "Ingen merknader",
  "createDescription": "Legg til viktig informasjon som en synlig merknad",
  "editDescription": "Legg til mer innhold, endre eller slett merknaden",
  "deleteConfirmTitle": "Er du sikker på at du vil slette merknaden?",
  "deleteConfirmDescription": "Hvis du sletter denne merknaden, vil den bli permanent fjernet. Du kan ikke gjenopprette den senere. Ønsker du å fortsette?",
  "save": "Lagre",
  "errorTitle": "Handlingen kunne ikke fullføres",
  "errorDescription": "Det er for tiden tekniske problemer. Prøv igjen senere."
}
